import * as consts from './ListingsConsts';
import { getOtherListingsRequest } from '../helpers/requestUtils';

export const getListings = () => {
    return (dispatch, getState) => {
        const tourId = getState().app.tourId;
        const tourType = getState().app.tourType;

        dispatch({ type: consts.GET_LISTINGS_PENDING });
        getOtherListingsRequest(tourId, tourType).then(data => {
            if (data.Error.length) {
                dispatch({ type: consts.GET_LISTINGS_REJECTED });
            } else {
                dispatch({
                    type: consts.GET_LISTINGS_FULFILLED,
                    payload: data.data
                });
            }
        }, () => {
            dispatch({type: consts.GET_LISTINGS_REJECTED});
        });
    }
}
